import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [role, setRole] = useState(null); // 'admin' | 'courier'
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      setUser(u);
      if (u) {
        // Role stored in localStorage after login (simple approach for free tier)
        const savedRole = localStorage.getItem('qurban_role');
        setRole(savedRole || 'admin');
      } else {
        setRole(null);
      }
      setLoading(false);
    });
    return unsub;
  }, []);

  const login = async (email, password, loginRole = 'admin') => {
    await signInWithEmailAndPassword(auth, email, password);
    localStorage.setItem('qurban_role', loginRole);
    setRole(loginRole);
  };

  const logout = async () => {
    await signOut(auth);
    localStorage.removeItem('qurban_role');
    setRole(null);
  };

  return (
    <AuthContext.Provider value={{ user, role, loading, login, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
